"use strict"
// ############################### Start der App
export function run() {
    window.SurveyRuntime = {
        useGridMode: true,
        currentSurvey: null,    // aktuelle Erhebungsdaten
        surveyData: null,       // vollständige Response von GET /daten (mit aktuellen und vorjahrigen Erhebungsdaten, Mitglieder-Informationen)
        mitgliedNummer: null,
        tooltip: null,
        controls: {},
        deviationCheckEnabled: false,
        deviationReasonAreaId: "#field-GrundAbweichung", // TODO: nach CONFIG
        totalRowTag: CONFIG.surveyHelper.Erhebung_Info.sumRows.slice(-1)[0],
        totalSum: null,
        totalColumnDataField: CONFIG.surveyHelper.Erhebung_Info.totalColumnField,
        currentErrorToast: null,
        currentGridInstance: null, // Achtung: das ist nur die  Grid-Instanz
        grids: {}, 
        addGrid: (name, grid) => {
            window.SurveyRuntime.grids[name] = {
                grid: grid,
                fixPending: true
            };
            return grid;
        },
        editorClosed: () => {
            SurveyRuntime.currentErrorToast?.hide();
        }
    }

    $("<div id='survey_toaster'>").appendTo("body");
    window.SurveyHooks = {}
    Customize.initialize();
    const path = window.location.pathname.toLowerCase().replace('.html', '');
    if (CONFIG.useStandardHeader) { $("header").show(); }
    if (CONFIG.useStandardFooter) { $("footer").show(); }

    if (CONFIG.useExtraordinarySurvey && path.endsWith(CONFIG.pathExtraordinarySurvey)) {
        window.CONFIG.specialLogin = "neu";
        document.title = Messages["LOGINX_DOC_TITLE"];
        $("#common-head-title").text(Messages["LOGINX_COMMONHEAD_TITLE"]);
        const popupTitle = Messages["LOGINX_POPUP_TITLE"];
        SurveyTools.login(continueAfterLogin, popupTitle);
        return;
    }
    if ((path.endsWith('/') || path.endsWith('/index') || path.endsWith('/login'))) {
        const url = new URL(window.CONFIG.serverApi + "/status");
        const request = {
            cache: false,
            url: url,
            contentType: 'application/json',
            method: 'GET',
            success: function (response) {
                if (response.activeState == 0) {
                    if (CONFIG.useIntegratedLogin) {
                        const popupTitle = Messages["LOGIN_POPUP_TITLE"];
                        SurveyTools.login(continueAfterLogin, popupTitle);
                    } else {
                        if (CONFIG.authenticationHandler) {
                            const authError = CONFIG.authenticationHandler(path, continueAfterLogin);
                            if (authError) {
                                SurveyTools.showErrorInPage(authError, "Fehler bei der Authentifizierung");
                            }
                        }
                    }
                } else {
                    SurveyTools.showErrorInPage(response.statusText, "Hinweis");
                }
            },
            error: function (jqXHR) {
                $("#common-head-info").hide();
                if (SurveyHooks.onLoginError) {
                    SurveyHooks.onLoginError(jqXHR);
                } else {
                    SurveyTools.showErrorInPage(jqXHR);
                }
            }
        };
        $.ajax(request);
    }
    // todo: Page not found
}
function continueAfterLogin(sessionInfo) {
    window.CONFIG.sessionId = sessionInfo.sessionId;
    window.CONFIG.customHeaders[window.CONFIG.authHeader] = window.CONFIG.sessionId;
    Survey.pageInit(sessionInfo);
}

// ############################### Logout
export function logout(reload) {
    const url = new URL(window.CONFIG.serverApi + "/logout");
    const request = {
        cache: false,
        url: url,
        contentType: 'application/json',
        method: 'POST',
        headers: window.CONFIG.customHeaders,
        success: function (response) {
            //alert("logged out")
            continueLogout(reload);
        },
        error: function (jqXHR) {
            //alert("log out failed");
            continueLogout(reload);
        }
    };
    $.ajax(request);
}
function continueLogout(reload) {
    if (reload) {
        location.reload();
    }
}
// ############################### LOGIN
let loginRequest = {
    login: "",
    password: ""
}
let loginCanClose = true;

export function login(continuation, popupTitle) {
    const template = function () {
        const container = $("<div />");
        const formElement = $("<div id='loginForm' />").appendTo(container);
        const summaryElement = $('<div id="loginCustomValidationSummary"/>').appendTo(container);
        summaryElement.dxValidationSummary();
        formElement.dxForm({
            labelMode: "outside",
            labelLocation: "left",
            formData: loginRequest,
            minColWidth: 450,
            colCount: 1,
            showValidationSummary: true,
            validationGroup: 'dataValidation',
            items: [
                {
                    dataField: "login", label: { text: "Anmeldename" },
                    validationRules: [
                        { type: "required", message: "Anmeldename muß angegeben werden." }
                    ]
                },
                {
                    dataField: "password", label: { text: "Passwort" },
                    editorOptions: { mode: "password" },
                    validationRules: [
                        { type: "required", message: "Passwort muß angegeben werden." }
                    ]
                }
            ]
        }); // formElement
        return container;
    }; // template

    const popup = $("#login").dxPopup({
        width: 600,
        height: "auto",
        showTitle: true,
        title: popupTitle, 
        showCloseButton: false,
        visible: false,
        shading: true,
        resizeEnabled: false,
        contentTemplate: template,
        onInitialized(e) {
            e.component.registerKeyHandler("escape", function (arg) { // ESC soll nicht das Popup schließen...
                arg.stopPropagation();
            });
        },
        onShown(e) {
            // das zusätzliche ValidationSummary-Widget für die Meldungen aus dem HTTP Request abholen
            popup.kavCustomValidationSummary = $("#loginCustomValidationSummary").dxValidationSummary("instance");
            popup.loginForm = $("#loginForm").dxForm("instance");
        },
        toolbarItems: [
            {
                widget: "dxButton",
                toolbar: "bottom",
                location: "after",
                options: {
                    text: "Abbrechen",
                    icon: "close",
                    onClick() {
                        // kein hide, dann stehen wir bei "back" von CONFIG.home wieder im Login Popup
                        location.href = CONFIG.home;
                    }
                }
            },
            {
                widget: "dxButton",
                toolbar: "bottom",
                location: "after",
                options: {
                    text: "OK",
                    icon: "check",
                    validationGroup: 'dataValidation',
                    onClick(e) {
                        const validationResult = e.validationGroup.validate();
                        if (validationResult.isValid) {
                            const url = new URL(window.CONFIG.serverApi + "/login");
                            const request = {
                                cache: false,
                                url: url,
                                contentType: 'application/json',
                                method: 'POST',
                                data: JSON.stringify(loginRequest),
                                success: function (response) {
                                    popup.hide();
                                    //continuation(response);
                                    continuation({ sessionId: response.sessionId, memberStatusCode: response.memberStatusCode });
                                },
                                error: function (jqXHR) {
                                    if (jqXHR.responseJSON && jqXHR.responseJSON.code) {
                                        SurveyTools.showRequestErrorInDialog("Fehler bei der Anmeldung", jqXHR, popup.kavCustomValidationSummary);
                                        //console.log(popup);
                                        popup.loginForm.getEditor("login").focus();
                                    } else {
                                        popup.hide();
                                        SurveyTools.showErrorInPage(jqXHR);
                                    }
                                }
                            };
                            $.ajax(request);
                        }
                    }
                }
            }
        ] // toolbarItems
    }).dxPopup("instance"); // popup
    popup.show();
}
// ############################### Survey Grid Support
export function showAnnotation(id, annotationsArray) {
    if (annotationsArray === undefined) {
        annotationsArray = window.CONFIG.surveyHelper.Erhebung_Info.annotations;
    }
    const anno = annotationsArray.find((a) => a.id === id);
    $("#survey_popup").dxPopup({
        title: "Anmerkung " + id,
        visible: true,
        hideOnOutsideClick: true,
        showCloseButton: true,
        shading: false,
        width: "800px",
        height: "auto",
        position: { my: 'center', at: 'center', of: $("#app") },
        contentTemplate: function (contentElement) {
            contentElement.append($('<div class="annotation_popup">').html(anno.text));
        }
    });
}
// Zeilentyp "von Zeile X": Summe der Werte in einer Spalte der "davon" - Zeilen muß <= dem Wert der Zelle der bezogenen Zeile in dieser Spalte sein
export function validateMaximumValues(data, oldRow, newData, dataField) {
    // data: rows der Matrix
    if (oldRow.maxRowRefId) {
        const rows = data.filter((r) => r.maxRowRefId === oldRow.maxRowRefId);
        const sum = rows.reduce((acc, r) => acc + (r.rowTag === oldRow.rowTag ? 0 : (r[dataField] ?? 0)), newData[dataField]);
        const referredRow = data.find((r) => r.rowTag === oldRow.maxRowRefId);
        if (sum > referredRow[dataField]) {
            return `Die Summe der Beschäftigtenanzahl der Zeilen ${niceJoin(rows.map((r) => r.shortName ?? '"' + r.label + '"'))} darf die Anzahl in Zeile ${referredRow.shortName ?? '"' + referredRow.label + '"'} nicht überschreiten.`;
        }
    } else {
        const rows = data.filter((r) => r.maxRowRefId === oldRow.rowTag);
        if (rows.length > 0) {
            const sum = rows.reduce((acc, r) => acc + (r[dataField] || 0), 0);
            if (sum > newData[dataField]) {
                return `Die Beschäftigtenanzahl in Zeile ${oldRow.shortName ?? '"' + changedRow.label + '"'} darf nicht kleiner sein als die Summe der Anzahlen in den Zeilen ${niceJoin(rows.map((r) => r.shortName ?? '"' + r.label + '"'))}. Korrigieren Sie bitte erst diese Anzahlen.`;            }
        }
    }
}
// ############################### Allgemeine Helfer
export function niceJoin(array, separator = ", ", lastSeparator = " und ") {
    if (!array || array.length === 0) {
        return "";
    }
    if (array.length === 1) {
        return array[0];
    }
    return array.slice(0, -1).join(separator) + lastSeparator + array[array.length - 1];
}
export function showErrorForGridEditor(errorMessage, editorElement, event) {
    if (errorMessage) {
        event.cancel = true;
        const config = {
            message: errorMessage,
            width: 400,
            displayTime: 10000,
            closeOnClick: true,
            hideOnOutsideClick: true,
            hideOnParentScroll: true,
            type: "error",
            position: {
                my: "left top",
                at: "left bottom",
                of: editorElement
            },
            onHiding: (e) => {
                e.component.dispose();
                SurveyRuntime.currentErrorToast = null;
            }
        }
        SurveyRuntime.currentErrorToast = $("#survey_toaster").dxToast(config).dxToast("instance");
        SurveyRuntime.currentErrorToast.show();
    }
}

export function buildApiRequestErrorText(jqXHR) {
    // aus der Rückgabe von $.ajax() einen möglichst sinnvollen Fehlertext bilden
    let errorInfo = undefined;
    try {
        errorInfo = JSON.parse(jqXHR.responseText);
    } catch {
        // kein Problem, nix machen!
    }
    let errorMessage = "";
    if (errorInfo) {
        if (errorInfo.code) {   // ausführliche Fehlermeldung aus dem Service
            errorMessage = `${errorInfo.message} (${errorInfo.code})`;
            if (errorInfo.errorDetails) {
                errorMessage += '<ul class="kaverror">';
                $.each(errorInfo.errorDetails, (i, v) => {
                    errorMessage += `<li class="kaverror">${v.message} (${v.code})</li>`
                });
                errorMessage += "</ul>";
            }
        } else if (errorInfo.title) { // eher knappe Info von der Runtime
            errorMessage = `${errorInfo.title} (${errorInfo.status}) + <br/>${errorInfo.responseText} `;
        }
    } else if (jqXHR.readyState == 0) {
        errorMessage = Messages['SERVICE_NOT_AVAILABLE'];
    } else if (jqXHR.status == 401) {
        errorMessage = Messages['NOT_LOGGEDIN'];
    } else {
        errorMessage = `Fehler ${jqXHR.status}`;
    }
    return errorMessage;
}
export function showErrorInPage(error, title) {
    // Fehler in div #errorBlock anzeigen
    // error: string, andernfalls wird jqXHR angenommen
    let message = undefined;
    if (typeof error === 'string') {
        message = error;
    } else {
        message = buildApiRequestErrorText(error)
    }
    $("#common-head-info").html('');
    $("#errorMessage").html(message);
    let heading = "Fehler";
    if (typeof title === 'string') {
        heading = title;
    }
    $("#errorHead").text(heading);
    $("#errorBlock").show();
}

export function showRequestErrorInDialog(heading, jqXHR, validationSummary) {
    // Requestfehler in einem DevEetreme validationSummary anzeigen 
    validationSummary.option("itemTemplate", validationSummaryItemTemplateRequestError);
    let errors = [heading, ""];
    let errorInfo = undefined;
    try {
        errorInfo = JSON.parse(jqXHR.responseText);
    } catch {
    }
    if (errorInfo) {
        if (errorInfo.code) {   // ausführliche Fehlermeldung aus dem Service
            errors[1] = `${errorInfo.message} (${errorInfo.code})`;
            if (errorInfo.errorDetails) {
                $.each(errorInfo.errorDetails, (i, v) => {
                    errors.push(v.message); // Code liefert hier keine zusätzliche Information
                });
            }
        } else if (errorInfo.title) { // eher knappe Info von der Runtime => Programmierfehler!
            errors[1] = `${errorInfo.title} (${errorInfo.status})`;
            errors.push(jqXHR.responseText);    // häßlich, sollte aber nicht oft zu sehen sein
        }
    } else if (jqXHR.readyState == 0) {
        errors[1] = Messages['SERVICE_NOT_AVAILABLE'];
    } else if (jqXHR.status == 401) {
        errors[1] = Messages['NOT_LOGGEDIN'];
    } else {
        errors[1] = `Fehler ${jqXHR.status}`;
    }

    validationSummary.option("items", errors);
}
function validationSummaryItemTemplateRequestError(data, index, element) {
    // index 0: heading
    // index 1: Fehlermeldung
    // index 2ff: ErrorDetails
    element.css("border-style", "none");    // keine Unterstreichung, weil keine Links
    if (index == 0) {
        element.append($('<div class="dx-item-content dx-validationsummary-item servervalidationsummary-item-head" >').text(data));
    } else if (index == 1) {
        element.append($('<div class="dx-item-content dx-validationsummary-item servervalidationsummary-item-error" >').text(data));
    } else {
        element.append($('<div class="dx-item-content dx-validationsummary-item servervalidationsummary-item-errordetail" >').text(data));
    }
}

export function html2Text(html) {
    return html.replace(/<[^>]*>/g, ' ').replace(/&shy;/g, '-').replace(/  /g, ' ').trim();
}
export function text2Html(text) {
    let html = text.replace(/\r\n|\r|\n/g, "<br/>");
    return html;
}


// ############################### Texte
let initTextDone = false;
export function InitDevextremeTexts() {
    if (initTextDone) return;
    initTextDone = true;
    let dict = {
        "de": {
            "Yes": "Ja",
            "No": "Nein",
            "dxPager-pageSizesAllText": "Alle"
        }
    };
    DevExpress.localization.loadMessages(dict);
    DevExpress.localization.locale("de");
}

export const Messages = {
    "SERVICE_NOT_AVAILABLE": 'Der API-Server ist nicht erreichbar. Schließen Sie diese Seite und versuchen Sie es später nochmals.',
    "NOT_LOGGEDIN": 'Sie sind nicht mehr angemeldet. Ihre Anmeldesitzung ist abgelaufen oder ungültig.'
}